import { render, staticRenderFns } from "./planSekkei.vue?vue&type=template&id=168664a6&scoped=true&"
import script from "./planSekkei.vue?vue&type=script&lang=js&"
export * from "./planSekkei.vue?vue&type=script&lang=js&"
import style0 from "./planSekkei.vue?vue&type=style&index=0&id=168664a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168664a6",
  null
  
)

export default component.exports